import { combineReducers } from 'redux';
import { SET_NAME, SET_GAME } from '../actions';

function name(state = '',action){
	switch(action.type){
		case SET_NAME:
			return action.payload;
		default:
			return state;
	}
};

function game(state = [],action){
	switch(action.type){
		case SET_GAME:
			return [...state,action.payload];
		default:
			return state;
	}
}

const rootReducers = combineReducers({
	name,
	game,
});

export default rootReducers;
